import { render } from "./PurchaseReceiveList.vue?vue&type=template&id=82130430"
import script from "./PurchaseReceiveList.vue?vue&type=script&lang=js"
export * from "./PurchaseReceiveList.vue?vue&type=script&lang=js"

import "./PurchaseReceiveList.vue?vue&type=style&index=0&id=82130430&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__